import React, {useState} from "react";
import {Tabs} from "antd";
import {TabsContainer} from "../../courier/courierDetail/courierDetailStyles";
import {BackofficeCollectionsTab} from "./backofficeCollectionsTab/BackofficeCollectionsTab";
import {BackofficePendingInvoicePaymentsTab} from "./backofficePendingInvoicePaymentsTab/BackofficePendingInvoicePaymentsTab";
import {BackofficeHasInvoicePaymentsTab} from "./backofficeHasInvoicePaymentsTab/BackofficeHasInvoicePaymentsTab";
import {BackofficeCompletedPaymentsTab} from "./backofficeCompletedPaymentsTab/BackofficeCompletedPaymentsTab";
import {BackofficeFailedPaymentsTab} from "./backofficeFailedPaymentsTab/BackofficeFailedPaymentsTab";

import {BackofficeConvertedToCashTab} from "./backofficeConvertedToCashTab/BackofficeConvertedToCashTab";
import {BackOfficePaidByBothCashAndCardTab} from "./backofficePaidByBothCashAndCard/BackofficePaidByBothCashAndCardTab";
import {BackofficeMatchableInvoicesPage} from "../matchableInvoices/BackofficeMatchableInvoicesPage";
export const BackofficeCashOnDeliveryPage = () => {
    const [activeTab, setActiveTab] = useState("collectionsTab");

    return (
        <TabsContainer activeKey={activeTab} onChange={key => setActiveTab(key)}>
            <Tabs.TabPane tab="Tahsilatlar" key="collectionsTab">
                <BackofficeCollectionsTab isTabOpened={activeTab === "collectionsTab"} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Fatura Bekleyen" key="pendingInvoicePaymentsTab">
                <BackofficePendingInvoicePaymentsTab isTabOpened={activeTab === "pendingInvoicePaymentsTab"} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Eşleştirme Bekleyen" key="matchableInvoicesTab">
                <BackofficeMatchableInvoicesPage isTabOpened={activeTab === "matchableInvoicesTab"} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Faturası Kesilmiş(Onay Bekleyen)" key="hasInvoicePaymentsTab">
                <BackofficeHasInvoicePaymentsTab isTabOpened={activeTab === "hasInvoicePaymentsTab"} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Ödemesi Alınan" key="completedPaymentsTab">
                <BackofficeCompletedPaymentsTab isTabOpened={activeTab === "completedPaymentsTab"} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Bankadan Dönen" key="failedPaymentsTab">
                <BackofficeFailedPaymentsTab isTabOpened={activeTab === "failedPaymentsTab"} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Nakite Dönen İşlemler" key="convertedToCashTab">
                <BackofficeConvertedToCashTab isTabOpened={activeTab === "convertedToCashTab"} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Nakit ve Kredi Kartından Aynı Anda Ödeme Alınan İşlemler" key="paidByBothCashAndCardTab">
                <BackOfficePaidByBothCashAndCardTab isTabOpened={activeTab === "paidByBothCashAndCardTab"} />
            </Tabs.TabPane>
        </TabsContainer>
    );
};
